import { useSelector } from "react-redux"

export const useAgenceGerant = () => {
    const currentAgence = useSelector(state => state.agences?.currentAgence)
    // console.log({ currentAgence });
    return { gerant: currentAgence?.gerant }
}